/*
  LIORIVE — cookie choices, on top of Shopify's own privacy banner (Settings › Customer privacy).
  1. Shopify sends the banner's policy link as /fr/policies/privacy-policy, a 404 on this French-only
     store: it is pointed at the store's real privacy policy. The banner is added to <body> by Shopify
     after load, hence the observer (direct children of <body> only).
  2. Footer "Gérer les cookies" ([data-lr-cookie-prefs]) reopens Shopify's preferences panel, so a choice
     can be changed at any time. Without Shopify's banner script the link stays a plain link to the policy.
*/
(() => {
  const policyUrl = `${window.Shopify?.routes?.root || '/'}policies/privacy-policy`;

  const fixPolicyLink = () => {
    const link = document.getElementById('shopify-pc__banner__body-policy-link');
    if (link && new URL(link.href, window.location.origin).pathname !== policyUrl) link.setAttribute('href', policyUrl);
  };

  fixPolicyLink();
  new MutationObserver(fixPolicyLink).observe(document.body, { childList: true });

  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-lr-cookie-prefs]');
    if (!link || typeof window.privacyBanner?.showPreferences !== 'function') return;
    event.preventDefault();
    window.privacyBanner.showPreferences();
  });
})();
